function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "88.706,165.023 90.071,468.293 410.445,468.293 410.445,24.986 209.254,24.986 "
  }), React.createElement("polygon", {
    style: {
      fill: "#E1E6E9"
    },
    points: "142.906,0 57.848,85.059 57.848,443.306 385.259,443.306 385.259,0 "
  }), React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "142.906,85.059 142.906,0 57.848,85.059 "
  }), React.createElement("g", null, React.createElement("rect", {
    x: 102.918,
    y: 125.415,
    style: {
      fill: "#D5D6DB"
    },
    width: 237.268,
    height: 17.851
  }), React.createElement("rect", {
    x: 127.894,
    y: 183.627,
    style: {
      fill: "#D5D6DB"
    },
    width: 187.317,
    height: 17.851
  }), React.createElement("rect", {
    x: 175.104,
    y: 67.209,
    style: {
      fill: "#D5D6DB"
    },
    width: 165.083,
    height: 17.851
  }), React.createElement("rect", {
    x: 102.918,
    y: 241.826,
    style: {
      fill: "#D5D6DB"
    },
    width: 237.268,
    height: 17.851
  }), React.createElement("rect", {
    x: 127.894,
    y: 300.02,
    style: {
      fill: "#D5D6DB"
    },
    width: 187.317,
    height: 17.851
  }), React.createElement("rect", {
    x: 102.918,
    y: 358.25,
    style: {
      fill: "#D5D6DB"
    },
    width: 237.268,
    height: 17.851
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.8fbfbbee.svg";
export { ForwardRef as ReactComponent };